const modulePaged = (http, params) => {
    return getHttp(http).post('/module/getPaged', {...params })
}

const moduleDelete = (http, params) => {
    return getHttp(http).post('/module/delete', {...params }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
}
const moduleSave = (http, params) => {
    return getHttp(http).post('/module/save', {...params })
}
const moduleGet = (http, params) => {
    if (params.id != undefined) {
        return getHttp(http).get('/module/get?id=' + params.id)
    }
    return getHttp(http).get('/module/get', {...params })
}

const moduleRegisterPaged = (http, params) => {
    return getHttp(http).post('/module/getRegisterPaged', {...params })
}

const moduleRegisterDelete = (http, params) => {
    return getHttp(http).post('/module/deleteRegister', {...params }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
}
const moduleRegisterSave = (http, params) => {
    return getHttp(http).post('/module/saveRegister', {...params })
}
const moduleRegisterGet = (http, params) => {
    if (params.id != undefined) {
        return getHttp(http).get('/module/getRegister?id=' + params.id)
    }
    return getHttp(http).get('/module/getRegister', {...params })
}
const moduleRoutePublish = (http, params) => {
    return getHttp(http).post('/module/publish', {...params }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
}
const moduleClearAll = (http, params) => {
    return getHttp(http).post('/module/clearAll', {...params }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
}


const httpSyncMenusRole = (http, params) => {
    return getHttp(http).post('/module/syncRoleMenus', {...params }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
}

const httpSyncMenus = (http, params) => {
    return getHttp(http).post('/module/syncMenus', {...params }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
}


function getHttp(http) {
    if (http === undefined) {
        return window.http
    }
    return http;
}

export {
    modulePaged, //模块管理列表
    moduleDelete, //模块管理列表删除
    moduleSave, //模块管理编辑新增保存
    moduleGet, //模块管理单个查询
    moduleRegisterPaged, //
    moduleRegisterGet,
    moduleRegisterSave,
    moduleRegisterDelete,
    moduleRoutePublish,
    moduleClearAll, //清除所有缓存
    httpSyncMenusRole,
    httpSyncMenus
}